import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Furniture } from '../../../models/furniture.model';
import { StpRegistrationStorageService } from '../../../services/stp-registration-storage.service';
import { Ministry } from '../../../models/ministry.model';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'app-ministry',
  templateUrl: './ministry.component.html',
  styleUrls: ['./ministry.component.scss'],
})
export class MinistryComponent implements OnInit {
  ministryForm!: FormGroup;
  ministry: Ministry;
  ministryUpdate : any;

  isEditMode : boolean;


  stpOwnershipType: { id: number; name: string }[] = [
    { id: 1, name: 'Public' },
    { id: 2, name: 'Private' },
    { id: 3, name: 'NGO' },
    { id: 4, name: 'Others' },
  ];

  ministryId: number;

  constructor(
    private fb: FormBuilder,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private notification: NzNotificationService,
    private nzMessageService: NzMessageService,
    private utilityService: UtilityService
  ) {
    this.ministryId = this.activatedRoute.snapshot.params.id;
    if(this.ministryId!=null)
    {
      this.isEditMode = true;
      this.stpRegistrationStorageService.getAgencyByMinistryId(this.ministryId).subscribe({
        next: (res: any) => {

          console.log(res.data);
          this.ministryUpdate = res.data;
          this.ministryForm.patchValue(
            {
              id : res.data.id,
              ministryName : res.data.ministryName,
              remarks : res.data.remarks,
              stpOwnershipType : res.data.stpOwnershipType.id
            }
          )


        },
        error: (error) => {
           //this.notification.warning('Warning!!! ', res.message);
        },
      });
    }

  }

  ngOnInit(): void {
    this.ministryForm = this.fb.group({
      id: [this.ministryId ?? ''],
      ministryName: ['', [Validators.required]],
      remarks: [''],
      stpOwnershipType: ['', [Validators.required]],
    });
  }

  submitForm(): void {
    console.log(this.ministryForm.value);
    this.ministry = this.ministryForm.value;
    this.stpRegistrationStorageService.addMinistry(this.ministry).subscribe({
      next: (response: any) =>{
        console.log(response);
        if(response.success)
        {
          this.notification.success('Success!', response.data);
        }else
        {
          this.notification.error('Failed!', response.data);
        }


      },
      error: (error: string) => this.notification.error('Failed', error),
    });

    this.resetForm();
  }

  resetForm(): void {
    this.ministryForm.reset();
  }


}
